module.exports = __webpack_public_path__ + "img/cosmos-small-dark.cb3676cb.svg";